window.global = window